import { environment } from "../environments/environment";

export interface EmailContext {
  screen_name: string;
  description: string;
  user_name: string;
  user_email: string;
  user_number?: string;
}

export interface SendEmailPayload {
  template_name: string; // e.g., "support_request.html"
  context: EmailContext;
  to_email: string;
  subject: string;
}

export interface SendEmailResponse {
  success: boolean;
  message?: string;
  [key: string]: unknown;
}

const EMAIL_BASE_URL =
  environment.masterConfigurationManagerURL ||
  process.env.APP_MASTER_CONFIGURATION_MANAGER_URL;

/**
 * Send support email via backend email service
 * Default endpoint: /email_send
 */
export async function sendEmail(
  payload: SendEmailPayload,
  endpoint: string = "/email_send"
): Promise<SendEmailResponse> {
  if (!EMAIL_BASE_URL) {
    throw new Error(
      "APP_MASTER_CONFIGURATION_MANAGER_URL is not configured. Cannot send email.",
    );
  }
  const url = new URL(endpoint, EMAIL_BASE_URL).href;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const text = await response.text().catch(() => "");
  const data = text ? (JSON.parse(text) as SendEmailResponse) : ({} as SendEmailResponse);

  if (!response.ok) {
    const message = data?.message || `Failed to send email (${response.status})`;
    throw new Error(message);
  }

  return data || { success: true };
}

// Convenience helper for the provided example payload
export async function sendSupportEmail(params: {
  screen_name: string;
  description: string;
  user_name: string;
  user_email: string;
  user_number?: string;
  to_email: string;
  subject: string;
}): Promise<SendEmailResponse> {
  const payload: SendEmailPayload = {
    template_name: "support_request.html",
    context: {
      screen_name: params.screen_name,
      description: params.description,
      user_name: params.user_name,
      user_email: params.user_email,
      user_number: params.user_number,
    },
    to_email: params.to_email,
    subject: params.subject,
  };
  return await sendEmail(payload);
}


